import { exhaustive } from "exhaustive"
import { FC, useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { ModulePopup, ModulePopupProps } from "../../Orders/Components/ModulePopup/ModulePopup"
import style from "./Login.module.css"
import { LoginForm } from "./LoginForm"
import { PasswordResetForm } from "./PasswordResetForm"
import { PasswordResetSent } from "./PasswordResetSent"

export enum LoginDialogView {
	Login = "Login",
	ResetPassword = "ResetPassword",
	ResetSent = "ResetSent",
}

type LoginDialogProps = ModulePopupProps & {
	defaultView?: LoginDialogView.Login | LoginDialogView.ResetPassword
	skipSetQueryParam?: boolean
}

export const LoginDialog: FC<LoginDialogProps> = ({ onClose: onCloseExt, defaultView, skipSetQueryParam, ...props }) => {
	const [queryParams, setQueryParams] = useSearchParams()

	const [show, setShow] = useState<LoginDialogView>(defaultView || LoginDialogView.Login)
	const [suggestedReset, setSuggestedReset] = useState<string>("")

	useEffect(() => {
		if (skipSetQueryParam) {
			return
		}

		if (!queryParams.has("login")) {
			queryParams.set("login", "")
			setQueryParams(queryParams)
		}
	}, [])

	function onClose(data?: string) {
		clearQueryParams()
		onCloseExt(data)
	}

	function clearQueryParams(clearRedirectTo?: boolean) {
		if (clearRedirectTo) {
			if (queryParams.has("redirectTo")) {
				queryParams.delete("redirectTo")
			}
		}

		if (queryParams.has("login")) {
			queryParams.delete("login")
			setQueryParams(queryParams)
		}
	}

	const onShowResetPassword = (emailSuggestion?: string) => {
		setSuggestedReset(emailSuggestion ?? "")
		setShow(LoginDialogView.ResetPassword)
	}

	const onResetSent = () => {
		setShow(LoginDialogView.ResetSent)
	}

	const component = exhaustive(show, {
		[LoginDialogView.Login]: () => <LoginForm onClose={onClose} onShowResetPassword={onShowResetPassword} />,
		[LoginDialogView.ResetPassword]: () => (
			<PasswordResetForm onClose={onClose} onResetSent={onResetSent} suggested={suggestedReset} />
		),
		[LoginDialogView.ResetSent]: () => <PasswordResetSent onClose={onClose} />,
	})

	const onCancel = () => {
		clearQueryParams(true)
		exhaustive(show, {
			[LoginDialogView.Login]: () => {
				onClose()
			},
			[LoginDialogView.ResetPassword]: () => {
				setShow(LoginDialogView.Login)
			},
			[LoginDialogView.ResetSent]: () => {
				onClose()
			},
		})
	}

	return (
		<ModulePopup {...props} onClose={onCancel}>
			<div className={style.outerWrapper}>{component}</div>
		</ModulePopup>
	)
}
